<template>
    <div>
        <Breadcrumbs main="Settings" title="Settings" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Admin details</h5>
							</div><br>
							
							<form @submit.prevent="updateAdmin" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Name</label>
											<input class="form-control" type="text" placeholder="" v-model="admin.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
											<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Email</label>
											<input class="form-control" type="text" placeholder="" v-model="admin.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
											<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Phone</label>
											<input class="form-control" type="text" placeholder="" v-model="admin.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"/>
											<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Admin Image</label>
											<input class="form-control" type="file" placeholder=""  @change="setFile($event)" accept="image/*"   v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
											<img v-if="admin.profile_img" :src="$image_url + admin.profile_img" class="profile-image mb-2" alt="">

											<img v-else class="profile-image mt-2" :src="preview_image"/>
											
											<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-4">
										
									</div>

									<div class="col-sm-2"></div>
									<div class="col-sm-2 float-end" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary float-end">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Change Password</h5>
							</div><br>
							
							<form @submit.prevent="updatePassword">
								<div class="row">
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Password</label>
											<input class="form-control" type="password" placeholder="" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>
											<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Confirm Password</label>														
											<input class="form-control" type="Password" placeholder="" v-model="confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>
											<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-2" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary float-end">Update</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					
				</div>
			</div>
		</div>


		
	</div>
</template>

<script>
	export default {
		name: "SettingsPage",
		data() {
			return {
				android_version: null,
				android_version_update: "",
				android_version_partial_update: "",
				ios_version: null,
				facebook: "",
				twitter: "",
				instagram: "",
				name: "",
				email: "",
				phone: "",
				range:"",
				facebook:"https://www.facebook.com",
				youtube:"https://www.youtube.com",
				instagram:"https://www.instagram.com",
				maintenance: 0,
				maintenance_reason: "",
				password: "",
				confirm_password: "",
				auto_approval: null,
				token: "",
				errors: {},
				admin: {},
				image: "",
				preview_image: "",
			};
		},

		created() {
			this.fetchSettings();
		},

		methods: {
			

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchSettings(page_url = null) {
				this.getToken();
				let url = "/trazio/settings";
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.admin = responseData.admin;
						
					})
					.catch((err) => console.log(err));
			},

			updateAdmin() {
				this.getToken();
				this.errors = {};
				let formData = new FormData();

				formData.append("name", this.admin.name);
				formData.append("email", this.admin.email);
				formData.append("mobile", this.admin.mobile);
				formData.append("image", this.image);

					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,
					},
					};
					this.loading = true;            
					
					this.$axios
					.post("trazio/updateTrazioAdmin", formData, config)
					.then((response) => {
						console.log(response);
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
							this.$router.push({ name: 'settings'});

						} else {
								this.$swal("", response.data.message, "error");
						}
						this.fetchSettings();
						this.clearForm();	
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (error.response) {
							if (error.response.status == 422) {
							if (error.response.data) {
								this.errors = error.response.data.message;
							}
							this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");
							} else if (error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							} else {
							this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));
			},

			updatePassword() 
			{
				this.getToken();
				let formData = new FormData();
				formData.append("password", this.password);
				formData.append("password_confirmation", this.confirm_password);

				let url = "/trazio/updatePassword";

				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchSettings();
						this.clearForm();
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			setFile(e) {
				this.image = e.target.files[0];
				this.preview_image = URL.createObjectURL(e.target.files[0]);
			},

			clearForm() {
				this.errors = {};
				this.password = "";
				this.confirm_password = "";
				this.image = "";
			},
		},
	};
</script>